/* eslint-disable @typescript-eslint/typedef */

/**
 * @desc Assessment API query parameter constants
 * Centralized query parameter keys for assessment-related endpoints
 */
export const AssessmentQueryParams = {
  /** Number of years for yearly summary count endpoint */
  NUMBER_OF_YEARS: 'numberOfYears',

  /** Number of assessments for top assessments endpoint */
  NUMBER_OF_ASSESSMENTS: 'numberOfAssessments',

  /** PDF type for assessment PDF download (full or management) */
  PDF_TYPE: 'type'
} as const;
